import api from './api';

export interface EndpointSuggestion {
  id?: string | null;
  generatedGroup: string | null;
  generatedParentGroup: string | null;
  generatedTag?: string[] | string | null;
  generatedSolution?: string | null;
  defectDescriptionSuggestion: string;
  confidence: number;
  rank: number;
}

export interface EndpointResponseMetadata {
  processedAt?: string;
  processingTime?: string;
  similarDefectsFound?: number;
  filteredCount?: number;
  basedOnSimilar?: boolean;
  aiPowered?: boolean;
  apiVersion?: string;
  service?: string;
  savedToHistory?: boolean;
}

export interface EndpointQueryResponse {
  success: boolean;
  timestamp?: string;
  similarDefectsFound?: number;
  suggestions: EndpointSuggestion[];
  metadata?: EndpointResponseMetadata;
  message?: string;
  error?: string;
  historyId?: string;
}

export interface EndpointTopSuggestion {
  generatedGroup: string | null;
  generatedParentGroup: string | null;
  defectDescriptionSuggestion: string;
  confidence: number;
}

export interface EndpointHistoryRecord {
  id: string;
  endpoint: string;
  timestamp: string | null;
  request: {
    defectDescription: string;
  };
  requestText: string;
  response: EndpointQueryResponse | null;
  success: boolean;
  statusCode: number | null;
  processingTime: string | null;
  similarDefectsFound: number;
  suggestionCount: number;
  historyId: string | null;
  savedToHistory: boolean;
  topSuggestion: EndpointTopSuggestion | null;
  username: string | null;
  source?: string | null;
  clientIp?: string | null;
}

export interface EndpointPagination {
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface EndpointHistoryResponse {
  success: boolean;
  data: EndpointHistoryRecord[];
  pagination: EndpointPagination;
}

interface EndpointHistoryParams {
  page?: number;
  limit?: number;
  search?: string;
}

function buildHistoryUrl(basePath: string, params: EndpointHistoryParams): string {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.search) queryParams.append('search', params.search);

  return queryParams.toString() ? basePath + '?' + queryParams.toString() : basePath;
}

export const endpointService = {
  async queryHybrid(defectDescription: string): Promise<EndpointQueryResponse> {
    const response = await api.post<EndpointQueryResponse>('/api/hybrid/app-query', {
      defectDescription
    });

    return response.data;
  },

  async getHybridHistory(params: EndpointHistoryParams = {}): Promise<EndpointHistoryResponse> {
    const response = await api.get<EndpointHistoryResponse>(buildHistoryUrl('/api/hybrid/history', params));
    return response.data;
  },

  async queryAIProcess(defectDescription: string): Promise<EndpointQueryResponse> {
    const response = await api.post<EndpointQueryResponse>('/api/aiprocess/query', {
      defectDescription
    });

    return response.data;
  },

  async getAIProcessHistory(params: EndpointHistoryParams = {}): Promise<EndpointHistoryResponse> {
    const response = await api.get<EndpointHistoryResponse>(buildHistoryUrl('/api/aiprocess/history', params));
    return response.data;
  }
};
